import { Loader2, RotateCcw, Save, X } from "lucide-react";
import { PlayerEditor } from "./PlayerEditor";
import { ThrowEditor } from "./ThrowEditor";
import { RunnerEditor } from "./RunnerEditor";

export const EditPanel = ({ play, draft, runners, selected, saving, onPlayer, onDraft, onSave, onCancel, onReset }) => (
  <div className="card space-y-4 edit-card" data-testid="edit-panel">
    <div className="flex items-center justify-between gap-2">
      <h2 className="font-heading text-xl font-bold uppercase tracking-wide">Edit play</h2>
      <button className="icon-btn !min-h-[40px] !min-w-[40px]" data-testid="edit-cancel-button" onClick={onCancel} aria-label="Cancel edit"><X size={20} /></button>
    </div>
    <PlayerEditor player={selected && draft.players[selected]} onChange={(patch) => onPlayer(selected, patch)} />
    <ThrowEditor fielder={play.fielder} throws={draft.throws} onChange={(throws) => onDraft({ throws })} />
    <RunnerEditor runners={runners} paths={draft.runner_paths} onChange={(runner_paths) => onDraft({ runner_paths })} />
    <div className="space-y-1.5">
      <span className="ctl-label">Explanation</span>
      <textarea data-testid="play-explanation-input" className="field-input w-full min-h-[64px]" maxLength={400} value={draft.explanation}
        onChange={(e) => onDraft({ explanation: e.target.value })} />
      <textarea data-testid="play-coach-note-input" className="field-input w-full min-h-[56px]" maxLength={500} value={draft.coach_note || ""}
        placeholder="Coaching note for the whole play (optional)" onChange={(e) => onDraft({ coach_note: e.target.value })} />
      <textarea data-testid="play-staff-note-input" className="field-input w-full min-h-[56px]" maxLength={500} value={draft.staff_note || ""}
        placeholder="Coaches-only note (hidden from players)" onChange={(e) => onDraft({ staff_note: e.target.value })} />
    </div>
    <div className="flex flex-wrap gap-2">
      <button className="btn-primary flex-1" data-testid="save-play-button" onClick={onSave} disabled={saving || !draft.explanation.trim()}>
        {saving ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />} Save team version
      </button>
      {play.customized && (
        <button className="btn-ghost" data-testid="reset-play-button" onClick={onReset} disabled={saving}>
          <RotateCcw size={18} /> Reset to default
        </button>
      )}
    </div>
  </div>
);
